import React from "react";
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// import './index.css'
import posthog from "posthog-js";
import { POSTHOG_KEY } from "./constants";
import App from "./components/App";

// Initialize PostHog with error handling
try {
  if (POSTHOG_KEY) {
    posthog.init(POSTHOG_KEY, { api_host: 'https://app.posthog.com' });
  } else {
    console.warn('PostHog key not provided, analytics will be disabled');
  }
} catch (error) {
  console.error('Failed to initialize PostHog:', error);
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
